/**
 * BESVOL Cart Limited Edition Enhancement
 * 购物车限量款特殊标注系统
 */

(function() {
  'use strict';

  // 限量款产品标签列表
  const LIMITED_TAGS = ['limited', '限量版', '限量'];
  
  // 购物车限量款标注初始化
  function initCartLimitedBadges() {
    // 等待购物车加载完成
    if (document.querySelector('.cart-item')) {
      processCartItems();
    }
    
    // 监听购物车变化（AJAX更新时）
    observeCartChanges();
  }
  
  // 处理购物车商品
  function processCartItems() {
    const cartItems = document.querySelectorAll('.cart-item');
    
    cartItems.forEach(item => {
      const productTitle = item.querySelector('.cart-item__name');
      if (!productTitle) return;
      
      // 检查是否已经是限量款
      if (item.dataset.limitedProcessed) return;
      
      // 从产品链接获取产品信息
      const productLink = productTitle.closest('a');
      if (!productLink) return;
      
      // 检查是否是限量款（通过URL或标题判断）
      checkProductIsLimited(productLink.href).then(isLimited => {
        if (isLimited) {
          addLimitedBadge(item, productTitle);
          addStockWarning(item);
        }
        item.dataset.limitedProcessed = 'true';
      });
    });
  }
  
  // 检查产品是否为限量款
  async function checkProductIsLimited(productUrl) {
    try {
      // 从产品URL提取handle
      const handle = productUrl.split('/products/')[1]?.split('?')[0];
      if (!handle) return false;
      
      // 检查本地存储的缓存
      const cached = localStorage.getItem(`besvol_product_${handle}`);
      if (cached) {
        const data = JSON.parse(cached);
        return data.isLimited || false;
      }
      
      // 从API获取产品信息
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return false;
      
      const product = await response.json();
      const isLimited = product.tags && product.tags.some(tag => 
        LIMITED_TAGS.includes(tag.toLowerCase())
      );
      
      // 缓存结果
      localStorage.setItem(`besvol_product_${handle}`, JSON.stringify({
        isLimited: isLimited,
        inventory: product.variants[0]?.inventory_quantity || 0,
        timestamp: Date.now()
      }));
      
      return isLimited;
    } catch (error) {
      console.warn('[BESVOL Cart] 检查产品类型失败:', error);
      return false;
    }
  }
  
  // 添加限量款徽标
  function addLimitedBadge(item, titleElement) {
    const badge = document.createElement('span');
    badge.className = 'cart-limited-badge';
    badge.innerHTML = '⚡限量款⚡';
    badge.style.cssText = `
      display: inline-block;
      margin-left: 8px;
      padding: 2px 8px;
      background: linear-gradient(135deg, #E63946, #C62828);
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1px;
      border-radius: 4px;
      vertical-align: middle;
    `;
    
    titleElement.appendChild(badge);
    item.classList.add('limited-cart-item');
  }
  
  // 添加库存警告
  function addStockWarning(item) {
    const detailsSection = item.querySelector('.cart-item__details');
    if (!detailsSection) return;
    
    // 获取产品库存（从缓存或重新获取）
    const productLink = item.querySelector('.cart-item__name');
    if (!productLink) return;
    
    const handle = productLink.href.split('/products/')[1]?.split('?')[0];
    if (!handle) return;
    
    const cached = localStorage.getItem(`besvol_product_${handle}`);
    if (cached) {
      const data = JSON.parse(cached);
      const inventory = data.inventory || 0;
      
      if (inventory > 0 && inventory < 10) {
        const warning = document.createElement('p');
        warning.className = 'cart-stock-warning';
        warning.innerHTML = `⚠ Low Stock: <span style="color:#E63946;font-weight:700;">${inventory} units left</span>`;
        warning.style.cssText = `
          margin: 8px 0 0;
          font-size: 12px;
          color: #E63946;
          font-family: 'Montserrat', sans-serif;
        `;
        
        detailsSection.appendChild(warning);
      }
    }
  }
  
  // 监听购物车变化
  function observeCartChanges() {
    const cartContainer = document.querySelector('.cart-items') || document.querySelector('[data-cart-items]');
    if (!cartContainer) return;
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setTimeout(processCartItems, 100);
        }
      });
    });
    
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
  
  // 页面加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartLimitedBadges);
  } else {
    initCartLimitedBadges();
  }
  
  // 监听购物车更新事件
  document.addEventListener('cart:updated', () => {
    setTimeout(processCartItems, 500);
  });
  
  // 暴露到全局
  window.BESVOLCartEnhancement = {
    refresh: processCartItems
  };
})();
